module.exports = __webpack_public_path__ + "mn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mn.svg
// module id = 695
// module chunks = 0